import React, { useMemo } from 'react'
import SevenStar from './7star'
import SevenStarJasem from './7starjasem'

const PayrollTable = ({
    company = '',
    data = [],
    store = '',
    payrollColumns = [],
    pickerColumnTemplates = null,
    personnelAllowanceNames = [],
    onPayrollRowsUpdate = () => {},
    allowanceColumnKeys = [],
    hiddenAllowanceColumnKeys = [],
    onHiddenAllowancePersisted,
}) => {
    /*

    if (company === '7starjasem')
        return <SevenStarJasem data={transformedRows} store={store} />
    */
    return (
        <SevenStar
            data={data}
            store={store}
            payrollColumns={payrollColumns}
            pickerColumnTemplates={pickerColumnTemplates}
            personnelAllowanceNames={personnelAllowanceNames}
            onPayrollRowsUpdate={onPayrollRowsUpdate}
            allowanceColumnKeys={allowanceColumnKeys}
            hiddenAllowanceColumnKeys={hiddenAllowanceColumnKeys}
            onHiddenAllowancePersisted={onHiddenAllowancePersisted}
        />
    )
}

export default PayrollTable